import { render, staticRenderFns } from "./DhmeManualImportModuleContents.vue?vue&type=template&id=e5c64f22&scoped=true"
import script from "./DhmeManualImportModuleContents.vue?vue&type=script&lang=js"
export * from "./DhmeManualImportModuleContents.vue?vue&type=script&lang=js"
import style0 from "./DhmeManualImportModuleContents.vue?vue&type=style&index=0&id=e5c64f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c64f22",
  null
  
)

export default component.exports